export default __webpack_public_path__ + "static/media/no.fe2c361f.svg";